const body = document.querySelector("body");

if (body.classList.contains("single-product")) {
  const textarea = document.querySelector("#comment");
  if (textarea) {
    textarea.placeholder = "Napisz opinię";
  }
}
